module.exports = __webpack_public_path__ + "static/services-head-97e199de211b50293356064fb4ef6966.png";